import React, { useState, useEffect, Fragment } from "react";
import logo from "../../../assets/images/endless-logo.png";
import Language from "./language";
import UserMenu from "./userMenu";
import Notification from "./notification";
import SearchHeader from "./searchHeader";
import { Link } from "react-router-dom";
import {
  AlignLeft,
  Maximize,
  Bell,
  MessageCircle,
  MoreHorizontal,
  Search,
  Sliders,
} from "react-feather";
import { useSelector, useDispatch } from "react-redux";
import { Popover, Radio, Button, Select } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { CustomDatePicker } from "../CustomDatePicker";
import { searchAdmin } from "../../../Graphs/Admin/searchAdmin";
import { searchUser } from "../../../Graphs/User/searchUser";
import { searchCategory } from "../../../Graphs/Category/searchCategory";
import { searchSubCategory } from "../../../Graphs/SubCategory/searchSubCategory";
import { searchLanguage } from "../../../Graphs/Language/searchLanguage";
import { searchCourse } from "../../../Graphs/Course/searchCourse";
import { searchModule } from "../../../Graphs/Module/searchModule";
import { searchCourseSession } from "../../../Graphs/CourseSession/searchCourseSession";
import { searchCourseSessionTopic } from "../../../Graphs/CourseSessionTopic/searchCourseSessionTopic";
import { getCorporateGroups } from "../../../Graphs/CorporateGroups/lsitCorporateGroups";
import { getAllCourse } from "../../../Graphs/Course/listCourse";

const Header = () => {
  const [sidebar, setSidebar] = useState(false);
  const [rightSidebar, setRightSidebar] = useState(true);
  const [headerbar, setHeaderbar] = useState(true);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterHovered, setFilterHovered] = useState(false);
  const [allAuthors, setAllAuthors] = useState([]);

  const primaryColor = localStorage.getItem("primary_color");

  const provideSearchRoutes = [
    "ADMIN",
    "USER",
    "CATEGORY",
    "SUB_CATEGORY",
    "LANGUAGE",
    "COURSE",
    "MODULE",
    "COURSESESSION",
    "COURSESESSIONTOPIC",
    "CORPORATEGROUP"
  ]; //routes name
  const placeHolderValues = {
    ADMIN: "Admin",
    USER: "User",
    CATEGORY: "Category",
    SUB_CATEGORY: "Sub Category",
    LANGUAGE: "Language",
    COURSE: "Course",
    MODULE: "Module",
    COURSESESSION: "Session",
    COURSESESSIONTOPIC: "Topic",
    CORPORATEGROUP: "Corporate Group"
  }; //placeholder name based on route name

  const openCloseSidebar = () => {
    if (sidebar) {
      setSidebar(!sidebar);
      document.querySelector(".page-main-header").classList.remove("open");
      document.querySelector(".page-sidebar").classList.remove("open");
    } else {
      setSidebar(!sidebar);
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
    }
  };

  function showRightSidebar() {
    if (rightSidebar) {
      setRightSidebar(!rightSidebar);
      document.querySelector(".right-sidebar").classList.add("show");
    } else {
      setRightSidebar(!rightSidebar);
      document.querySelector(".right-sidebar").classList.remove("show");
    }
  }

  //full screen function
  function goFull() {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  const dispatch = useDispatch();
  const searchText = useSelector((content) => content.auth.searchText);
  const routeName = useSelector((content) => content.auth.routeName);
  const authToken = useSelector((content) => content.auth.authToken);
  const statusFilter = useSelector((content) => content.auth.statusFilter);
  const dateRangeFilter = useSelector((content) => content.auth.dateRangeFilter);
  const courseAuthorFilter = useSelector((content) => content.auth.courseAuthorFilter);
  const coursePriceFilter = useSelector((content) => content.auth.coursePriceFilter);
  const courseDifficultyFilter = useSelector((content) => content.auth.courseDifficultyFilter);
  const listCourseData = useSelector((content) => content.course.listCourseData) || [];
  const listUserData = useSelector((content) => content.user.listUserData) || [];
  const listModuleData = useSelector((content) => content.module.listModuleData) || [];
  const listCourseSessionData = useSelector((content) => content.coursesession.listCourseSessionData) || [];
  const userCategoryFilter = useSelector((content) => content.auth.userCategoryFilter);
  const userSiteFilter = useSelector((content) => content.auth.userSiteFilter);
  const userProgressFilter = useSelector((content) => content.auth.userProgressFilter);
  const moduleCourseFilter = useSelector((content) => content.auth.moduleCourseFilter);
  const sessionCourseFilter = useSelector((content) => content.auth.sessionCourseFilter);
  const topicCourseFilter = useSelector((content) => content.auth.topicCourseFilter);
  const topicSessionFilter = useSelector((content) => content.auth.topicSessionFilter);
  const topicTypeFilter = useSelector((content) => content.auth.topicTypeFilter);
  const listCourseSessionTopicData = useSelector((content) => content.coursesessiontopic.listCourseSessionTopicData) || [];

  useEffect(() => {
    const fetchAllAuthors = async () => {
      if (authToken && routeName === "COURSE") {
        try {
          let courseData = await getAllCourse(authToken, 0, 1000000);
          if (courseData && courseData.status === 200 && courseData.data) {
            const unique = Array.from(
              new Set(
                courseData.data
                  .map((course) => course.author)
                  .filter(Boolean)
                  .map((author) => author.trim())
              )
            ).sort();
            setAllAuthors(unique);
          }
        } catch (e) {
          console.log("Error fetching all authors", e);
        }
      }
    };
    fetchAllAuthors();
  }, [authToken, routeName, listCourseData]);

  const uniqueUserCategories = Array.from(
    new Set(
      listUserData
        .map((user) => user.category)
        .filter(Boolean)
        .map((c) => c.trim())
    )
  ).sort();

  const uniqueUserSites = Array.from(
    new Set(
      listUserData
        .map((user) => user.site)
        .filter(Boolean)
        .map((s) => s.trim())
    )
  ).sort();

  const uniqueModuleCourses = Array.from(
    new Set(
      listModuleData
        .map((mod) => mod.courseData && mod.courseData[0] && mod.courseData[0].name)
        .filter(Boolean)
        .map((name) => name.trim())
    )
  ).sort();

  const uniqueSessionCourses = Array.from(
    new Set(
      listCourseSessionData
        .map((sess) => sess.courseData && sess.courseData[0] && sess.courseData[0].name)
        .filter(Boolean)
        .map((name) => name.trim())
    )
  ).sort();

  const uniqueTopicCourses = Array.from(
    new Set(
      listCourseSessionTopicData
        .map((topic) => topic.courseData && topic.courseData[0] && topic.courseData[0].name)
        .filter(Boolean)
        .map((name) => name.trim())
    )
  ).sort();

  const uniqueTopicSessions = Array.from(
    new Set(
      listCourseSessionTopicData
        .map((topic) => topic.sessionData && topic.sessionData[0] && topic.sessionData[0].name)
        .filter(Boolean)
        .map((name) => name.trim())
    )
  ).sort();

  const filterContent = (
    <div style={{ padding: "12px 20px", width: "360px" }}>
      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Status</div>
        <Radio.Group
          value={statusFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_STATUS_FILTER", statusFilter: e.target.value })}
        >
          <Radio value="all">All</Radio>
          <Radio value="active">Active</Radio>
          <Radio value="inactive">Inactive</Radio>
        </Radio.Group>
      </div>

      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Category</div>
        <select
          value={userCategoryFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_USER_CATEGORY_FILTER", userCategoryFilter: e.target.value })}
          style={{
            width: "100%",
            padding: "5px 8px",
            borderRadius: "4px",
            border: "1px solid #d9d9d9",
            backgroundColor: "#fff",
            outline: "none",
            cursor: "pointer",
            height: "32px",
            fontSize: "13px"
          }}
        >
          <option value="all">All Categories</option>
          {uniqueUserCategories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Site</div>
        <select
          value={userSiteFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_USER_SITE_FILTER", userSiteFilter: e.target.value })}
          style={{
            width: "100%",
            padding: "5px 8px",
            borderRadius: "4px",
            border: "1px solid #d9d9d9",
            backgroundColor: "#fff",
            outline: "none",
            cursor: "pointer",
            height: "32px",
            fontSize: "13px"
          }}
        >
          <option value="all">All Sites</option>
          {uniqueUserSites.map((site) => (
            <option key={site} value={site}>
              {site}
            </option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Progress</div>
        <Radio.Group
          value={userProgressFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_USER_PROGRESS_FILTER", userProgressFilter: e.target.value })}
        >
          <Radio value="all">All</Radio>
          <Radio value="notStarted">Not Started (0%)</Radio>
          <Radio value="inProgress">In Progress</Radio>
          <Radio value="completed">Completed (100%)</Radio>
        </Radio.Group>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Last Visited Range</div>
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <CustomDatePicker
            value={dateRangeFilter ? dateRangeFilter[0] : null}
            placeholder="From Date"
            onChange={(val) => {
              const currentRange = dateRangeFilter || [null, null];
              dispatch({ type: "SET_DATE_RANGE_FILTER", dateRangeFilter: [val, currentRange[1]] });
            }}
            style={{ flex: 1 }}
            portalId={null}
          />
          <span style={{ color: "#aaa" }}>to</span>
          <CustomDatePicker
            value={dateRangeFilter ? dateRangeFilter[1] : null}
            placeholder="To Date"
            onChange={(val) => {
              const currentRange = dateRangeFilter || [null, null];
              dispatch({ type: "SET_DATE_RANGE_FILTER", dateRangeFilter: [currentRange[0], val] });
            }}
            style={{ flex: 1 }}
            portalId={null}
          />
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <Button
          size="small"
          onClick={() => {
            dispatch({ type: "SET_STATUS_FILTER", statusFilter: "all" });
            dispatch({ type: "SET_DATE_RANGE_FILTER", dateRangeFilter: null });
            dispatch({ type: "SET_USER_CATEGORY_FILTER", userCategoryFilter: "all" });
            dispatch({ type: "SET_USER_SITE_FILTER", userSiteFilter: "all" });
            dispatch({ type: "SET_USER_PROGRESS_FILTER", userProgressFilter: "all" });
            setFilterVisible(false);
          }}
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => setFilterVisible(false)}
        >
          Apply
        </Button>
      </div>
    </div>
  );

  const courseFilterContent = (
    <div style={{ padding: "12px 20px", width: "320px" }}>
      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Publish Status</div>
        <Radio.Group
          value={statusFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_STATUS_FILTER", statusFilter: e.target.value })}
        >
          <Radio value="all">All</Radio>
          <Radio value="active">Published</Radio>
          <Radio value="inactive">Draft</Radio>
        </Radio.Group>
      </div>

      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Author</div>
        <select
          value={courseAuthorFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_COURSE_AUTHOR_FILTER", courseAuthorFilter: e.target.value })}
          style={{
            width: "100%",
            padding: "5px 8px",
            borderRadius: "4px",
            border: "1px solid #d9d9d9",
            backgroundColor: "#fff",
            outline: "none",
            cursor: "pointer",
            height: "32px",
            fontSize: "13px"
          }}
        >
          <option value="all">All Authors</option>
          {allAuthors.map((author) => (
            <option key={author} value={author}>
              {author}
            </option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Price</div>
        <Radio.Group
          value={coursePriceFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_COURSE_PRICE_FILTER", coursePriceFilter: e.target.value })}
        >
          <Radio value="all">All</Radio>
          <Radio value="free">Free</Radio>
          <Radio value="paid">Paid</Radio>
        </Radio.Group>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Difficulty Level</div>
        <Radio.Group
          value={courseDifficultyFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_COURSE_DIFFICULTY_FILTER", courseDifficultyFilter: e.target.value })}
        >
          <Radio value="all">All</Radio>
          <Radio value="Beginner">Beginner</Radio>
          <Radio value="Intermediate">Intermediate</Radio>
          <Radio value="Master">Master</Radio>
        </Radio.Group>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <Button
          size="small"
          onClick={() => {
            dispatch({ type: "SET_STATUS_FILTER", statusFilter: "all" });
            dispatch({ type: "SET_COURSE_AUTHOR_FILTER", courseAuthorFilter: "all" });
            dispatch({ type: "SET_COURSE_PRICE_FILTER", coursePriceFilter: "all" });
            dispatch({ type: "SET_COURSE_DIFFICULTY_FILTER", courseDifficultyFilter: "all" });
            setFilterVisible(false);
          }}
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => setFilterVisible(false)}
        >
          Apply
        </Button>
      </div>
    </div>
  );

  const moduleFilterContent = (
    <div style={{ padding: "12px 20px", width: "300px" }}>
      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Status</div>
        <Radio.Group
          value={statusFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_STATUS_FILTER", statusFilter: e.target.value })}
        >
          <Radio value="all">All</Radio>
          <Radio value="active">Active</Radio>
          <Radio value="inactive">Inactive</Radio>
        </Radio.Group>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Course</div>
        <select
          value={moduleCourseFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_MODULE_COURSE_FILTER", moduleCourseFilter: e.target.value })}
          style={{
            width: "100%",
            padding: "3px 8px",
            borderRadius: "4px",
            border: "1px solid #d9d9d9",
            backgroundColor: "#fff",
            outline: "none",
            cursor: "pointer",
            height: "28px",
            fontSize: "13px"
          }}
        >
          <option value="all">All Courses</option>
          {uniqueModuleCourses.map((course) => (
            <option key={course} value={course}>{course}</option>
          ))}
        </select>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <Button
          size="small"
          onClick={() => {
            dispatch({ type: "SET_STATUS_FILTER", statusFilter: "all" });
            dispatch({ type: "SET_MODULE_COURSE_FILTER", moduleCourseFilter: "all" });
            setFilterVisible(false);
          }}
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => setFilterVisible(false)}
        >
          Apply
        </Button>
      </div>
    </div>
  );

  const sessionFilterContent = (
    <div style={{ padding: "12px 20px", width: "300px" }}>
      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Status</div>
        <Radio.Group
          value={statusFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_STATUS_FILTER", statusFilter: e.target.value })}
        >
          <Radio value="all">All</Radio>
          <Radio value="active">Active</Radio>
          <Radio value="inactive">Inactive</Radio>
        </Radio.Group>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Course</div>
        <select
          value={sessionCourseFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_SESSION_COURSE_FILTER", sessionCourseFilter: e.target.value })}
          style={{
            width: "100%",
            padding: "3px 8px",
            borderRadius: "4px",
            border: "1px solid #d9d9d9",
            backgroundColor: "#fff",
            outline: "none",
            cursor: "pointer",
            height: "28px",
            fontSize: "13px"
          }}
        >
          <option value="all">All Courses</option>
          {uniqueSessionCourses.map((course) => (
            <option key={course} value={course}>{course}</option>
          ))}
        </select>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <Button
          size="small"
          onClick={() => {
            dispatch({ type: "SET_STATUS_FILTER", statusFilter: "all" });
            dispatch({ type: "SET_SESSION_COURSE_FILTER", sessionCourseFilter: "all" });
            setFilterVisible(false);
          }}
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => setFilterVisible(false)}
        >
          Apply
        </Button>
      </div>
    </div>
  );

  const topicFilterContent = (
    <div style={{ padding: "12px 20px", width: "300px" }}>
      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Status</div>
        <Radio.Group
          value={statusFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_STATUS_FILTER", statusFilter: e.target.value })}
        >
          <Radio value="all">All</Radio>
          <Radio value="active">Active</Radio>
          <Radio value="inactive">Inactive</Radio>
        </Radio.Group>
      </div>

      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Course</div>
        <select
          value={topicCourseFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_TOPIC_COURSE_FILTER", topicCourseFilter: e.target.value })}
          style={{
            width: "100%",
            padding: "3px 8px",
            borderRadius: "4px",
            border: "1px solid #d9d9d9",
            backgroundColor: "#fff",
            outline: "none",
            cursor: "pointer",
            height: "28px",
            fontSize: "13px"
          }}
        >
          <option value="all">All Courses</option>
          {uniqueTopicCourses.map((course) => (
            <option key={course} value={course}>{course}</option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: "14px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Session</div>
        <select
          value={topicSessionFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_TOPIC_SESSION_FILTER", topicSessionFilter: e.target.value })}
          style={{
            width: "100%",
            padding: "3px 8px",
            borderRadius: "4px",
            border: "1px solid #d9d9d9",
            backgroundColor: "#fff",
            outline: "none",
            cursor: "pointer",
            height: "28px",
            fontSize: "13px"
          }}
        >
          <option value="all">All Sessions</option>
          {uniqueTopicSessions.map((session) => (
            <option key={session} value={session}>{session}</option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "600", marginBottom: "6px", fontSize: "13px", color: "#333" }}>Type</div>
        <Radio.Group
          value={topicTypeFilter || "all"}
          onChange={(e) => dispatch({ type: "SET_TOPIC_TYPE_FILTER", topicTypeFilter: e.target.value })}
        >
          <Radio value="all">All</Radio>
          <Radio value="study">Study</Radio>
          <Radio value="quiz">Quiz</Radio>
        </Radio.Group>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <Button
          size="small"
          onClick={() => {
            dispatch({ type: "SET_STATUS_FILTER", statusFilter: "all" });
            dispatch({ type: "SET_TOPIC_COURSE_FILTER", topicCourseFilter: "all" });
            dispatch({ type: "SET_TOPIC_SESSION_FILTER", topicSessionFilter: "all" });
            dispatch({ type: "SET_TOPIC_TYPE_FILTER", topicTypeFilter: "all" });
            setFilterVisible(false);
          }}
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => setFilterVisible(false)}
        >
          Apply
        </Button>
      </div>
    </div>
  );

  console.log("Route Name: ", routeName)

  async function handleSearchKeyword(textValue) {
    console.log("!!!!!!!!!!!onchange method", textValue, searchText);

    if (routeName === "ADMIN") {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: textValue,
      });
      dispatch({
        type: "SET_SEARCH_LOADER",
        searchLoader: true,
      });
      await listSearchAdminData(textValue);
    }

    if (routeName === "USER") {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: textValue,
      });
      // Client-side filtering handles search on Users — no API call needed
    }

    if (routeName === "CATEGORY") {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: textValue,
      });
      dispatch({
        type: "SET_SEARCH_LOADER",
        searchLoader: true,
      });
      await listSearchCategoryData(textValue);
    }

    if (routeName === "SUB_CATEGORY") {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: textValue,
      });
      dispatch({
        type: "SET_SEARCH_LOADER",
        searchLoader: true,
      });
      await listSearchSubCategoryData(textValue);
    }

    if (routeName === "LANGUAGE") {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: textValue,
      });
      dispatch({
        type: "SET_SEARCH_LOADER",
        searchLoader: true,
      });
      await listSearchLanguageData(textValue);
    }

    if (routeName === "COURSE") {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: textValue,
      });
      dispatch({
        type: "SET_SEARCH_LOADER",
        searchLoader: true,
      });
      await listSearchCourseData(textValue);
    }

    if (routeName === "MODULE") {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: textValue,
      });
      // Client-side filtering handles search on Modules — no API call needed
    }

    if (routeName === "COURSESESSION") {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: textValue,
      });
      // Client-side filtering handles search on Sessions — no API call needed
    }

    if (routeName === "COURSESESSIONTOPIC") {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: textValue,
      });
      // Client-side filtering handles search on Topics — no API call needed
    }

    if (routeName === "CORPORATEGROUP") {
      dispatch({
        type: "SET_SEARCH_TEXT",
        searchText: textValue,
      });
      dispatch({
        type: "SET_SEARCH_LOADER",
        searchLoader: true,
      });
      await listSearchCorporateGroupData(textValue);
    }
  }

  async function listSearchAdminData(textValue) {
    let adminData = await searchAdmin(authToken, textValue, 0, 10);

    if (adminData.status === 200) {
      //set user data
      await dispatch({
        type: "SET_LIST_ADMIN_DATA",
        // listAdminData: adminData.data.docs,
        listAdminData: adminData.data,
      });
      await dispatch({
        type: "SET_LIST_ADMIN_DATA_TOTAL",
        listAdminDataTotal: adminData.total,
      });
    }
    dispatch({
      type: "SET_SEARCH_LOADER",
      searchLoader: false,
    });
  }

  async function listSearchUserData(textValue) {
    let userData = await searchUser(authToken, textValue, 0, 1000000);

    if (userData.status === 200) {
      //set user data
      await dispatch({
        type: "SET_LIST_USER_DATA",
        // listUserData: userData.data.docs,
        listUserData: userData.data,
      });
      await dispatch({
        type: "SET_LIST_USER_DATA_TOTAL",
        listUserDataTotal: userData.total,
      });
    }
    dispatch({
      type: "SET_SEARCH_LOADER",
      searchLoader: false,
    });
  }

  async function listSearchCategoryData(textValue) {
    let categoryData = await searchCategory(authToken, textValue, 0, 10);

    if (categoryData.status === 200) {
      //set user data
      await dispatch({
        type: "SET_LIST_CATEGORY_DATA",
        // listCategoryData: categoryData.data.docs,
        listCategoryData: categoryData.data,
      });
      await dispatch({
        type: "SET_LIST_CATEGORY_DATA_TOTAL",
        listCategoryDataTotal: categoryData.total,
      });
    }
    dispatch({
      type: "SET_SEARCH_LOADER",
      searchLoader: false,
    });
  }

  async function listSearchSubCategoryData(textValue) {
    let subCategoryData = await searchSubCategory(authToken, textValue, 0, 10);

    if (subCategoryData.status === 200) {
      //set user data
      await dispatch({
        type: "SET_LIST_SUB_CATEGORY_DATA",
        // listCategoryData: subCategoryData.data.docs,
        listSubCategoryData: subCategoryData.data,
      });
      await dispatch({
        type: "SET_LIST_SUB_CATEGORY_DATA_TOTAL",
        listSubCategoryDataTotal: subCategoryData.total,
      });
    }
    dispatch({
      type: "SET_SEARCH_LOADER",
      searchLoader: false,
    });
  }

  async function listSearchLanguageData(textValue) {
    let languageData = await searchLanguage(authToken, textValue, 0, 10);

    if (languageData.status === 200) {
      //set user data
      await dispatch({
        type: "SET_LIST_LANGUAGE_DATA",
        // listCategoryData: languageData.data.docs,
        listLanguageData: languageData.data,
      });
      await dispatch({
        type: "SET_LIST_LANGUAGE_DATA_TOTAL",
        listLanguageDataTotal: languageData.total,
      });
    }
    dispatch({
      type: "SET_SEARCH_LOADER",
      searchLoader: false,
    });
  }

  async function listSearchCourseData(textValue) {
    let courseData = await searchCourse(authToken, textValue, 0, 1000000);

    if (courseData.status === 200) {
      //set user data
      await dispatch({
        type: "SET_LIST_COURSE_DATA",
        // listCategoryData: courseData.data.docs,
        listCourseData: courseData.data,
      });
      await dispatch({
        type: "SET_LIST_COURSE_DATA_TOTAL",
        listCourseDataTotal: courseData.total,
      });
    }
    dispatch({
      type: "SET_SEARCH_LOADER",
      searchLoader: false,
    });
  }

  async function listSearchModuleData(textValue) {
    let moduleData = await searchModule(authToken, textValue, 0, 10);

    if (moduleData.status === 200) {
      //set user data
      await dispatch({
        type: "SET_LIST_MODULE_DATA",
        // listModuleData: moduleData.data.docs,
        listModuleData: moduleData.data,
      });
      await dispatch({
        type: "SET_LIST_MODULE_DATA_TOTAL",
        listModuleDataTotal: moduleData.total,
      });
    }
    dispatch({
      type: "SET_SEARCH_LOADER",
      searchLoader: false,
    });
  }

  async function listSearchSessionData(textValue) {
    let sessionData = await searchCourseSession(authToken, textValue, 0, 10);

    if (sessionData.status === 200) {
      //set user data
      await dispatch({
        type: "SET_LIST_COURSE_SESSION_DATA",
        listCourseSessionData: sessionData.data,
      });
      await dispatch({
        type: "SET_LIST_COURSE_SESSION_DATA_TOTAL",
        listCourseSessionDataTotal: sessionData.total,
      });
    }
    dispatch({
      type: "SET_SEARCH_LOADER",
      searchLoader: false,
    });
  }

  async function listSearchTopicData(textValue) {
    let topicData = await searchCourseSessionTopic(authToken, textValue, 0, 10);

    if (topicData.status === 200) {
      //set user data
      await dispatch({
        type: "SET_LIST_COURSE_SESSION_TOPIC_DATA",
        // listCategoryData: topicData.data.docs,
        listCourseSessionTopicData: topicData.data,
      });
      await dispatch({
        type: "SET_LIST_COURSE_SESSION_TOPIC_DATA_TOTAL",
        listCourseSessionTopicDataTotal: topicData.total,
      });
    }
    dispatch({
      type: "SET_SEARCH_LOADER",
      searchLoader: false,
    });
  }

  async function listSearchCorporateGroupData(textValue) {
    let topicData = await getCorporateGroups(authToken, 0, 10, textValue);

    console.log("Topic Data: ", topicData.data)

    if (topicData.status === 200) {
      //set user data
      await dispatch({
        type: "SET_LIST_CORPORATE_GROUP_DATA",
        // listCategoryData: topicData.data.docs,
        listCorporateGroup: topicData.data,
      });
      await dispatch({
        type: "SET_LIST_COURSE_SESSION_TOPIC_DATA_TOTAL",
        listCorporateGroupTotal: topicData.total,
      });
    }
    dispatch({
      type: "SET_SEARCH_LOADER",
      searchLoader: false,
    });
  }

  return (
    <Fragment>
      <div className="page-main-header">
        <div className="main-header-right row">
          <div className="main-header-left d-lg-none">
            <div className="logo-wrapper">
              <Link to="/dashboard/default">
                {/* <img className="img-fluid" src={logo} alt="" /> */}
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "0px",
                    fontSize: "25px",
                    fontWeight: "bold",
                  }}
                >
                  Trainovate
                </div>
              </Link>
            </div>
          </div>
          <div className="mobile-sidebar d-block">
            <div className="media-body text-right switch-sm">
              <label className="switch">
                <a href="#javascript" onClick={() => openCloseSidebar()}>
                  <AlignLeft />
                </a>
              </label>
            </div>
          </div>
          <div className="nav-right col p-0">
            <ul className={`nav-menus ${headerbar ? "" : "open"}`}>
              <li>
                <Fragment>
                  <div>
                    {provideSearchRoutes.includes(routeName) ? (
                      <form className="form-inline search-form" style={{ display: "flex", alignItems: "center", flexFlow: "row nowrap" }} onSubmit={(e) => e.preventDefault()}>
                        <div className="form-group" style={{ display: "flex", alignItems: "center", flexFlow: "row nowrap" }}>
                          <input
                            className="form-control-plaintext searchIcon"
                            type="text"
                            placeholder={
                              placeHolderValues && placeHolderValues[routeName]
                                ? "Search " + placeHolderValues[routeName]
                                : "Search"
                            }
                            onChange={(e) =>
                              handleSearchKeyword(e.target.value)
                            }
                          />
                          <span className="d-sm-none mobile-search">
                            <Search />
                          </span>
                        </div>
                        {(routeName === "USER" || routeName === "COURSE" || routeName === "MODULE" || routeName === "COURSESESSION" || routeName === "COURSESESSIONTOPIC") && (
                          <Popover
                            content={
                              routeName === "USER" ? filterContent
                                : routeName === "COURSE" ? courseFilterContent
                                  : routeName === "MODULE" ? moduleFilterContent
                                    : routeName === "COURSESESSION" ? sessionFilterContent
                                      : topicFilterContent
                            }
                            title={
                              routeName === "USER" ? "Filter Users"
                                : routeName === "COURSE" ? "Filter Courses"
                                  : routeName === "MODULE" ? "Filter Modules"
                                    : routeName === "COURSESESSION" ? "Filter Sessions"
                                      : "Filter Topics"
                            }
                            trigger="click"
                            visible={filterVisible}
                            onVisibleChange={(visible) => setFilterVisible(visible)}
                            placement="bottomRight"
                            transitionName=""
                          >
                            <Button
                              type="text"
                              icon={
                                <Sliders
                                  size={18}
                                  style={{
                                    color: primaryColor || "#4466f2",
                                    marginTop: "0px",
                                    display: "block",
                                    transition: "color 0.3s ease"
                                  }}
                                />
                              }
                              onMouseEnter={() => setFilterHovered(true)}
                              onMouseLeave={() => setFilterHovered(false)}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "none",
                                boxShadow: "none",
                                marginLeft: "4px",
                                background: filterHovered ? "rgba(68, 102, 242, 0.16)" : "rgba(68, 102, 242, 0.08)",
                                cursor: "pointer",
                                padding: "0 14px",
                                height: "36px",
                                minWidth: "48px",
                                borderRadius: "18px",
                                transition: "all 0.3s ease",
                                alignSelf: "center",
                                flexShrink: 0
                              }}
                            />
                          </Popover>
                        )}
                      </form>
                    ) : null}
                  </div>
                </Fragment>
              </li>
              {/* <li>
                <SearchHeader />
              </li> */}
              {/* <li>
                <a onClick={goFull} className="text-dark" href="#!">
                  <Maximize />
                </a>
              </li> */}
              {/* <li className="onhover-dropdown">
                <a className="txt-dark" href="#javascript">
                  <h6>EN</h6></a>
                <Language />
              </li>
              <li className="onhover-dropdown">
                <Notification />
                <Bell />
                <span className="dot"></span>
                <Notification />
              </li> */}
              <li style={{ marginRight: "0px" }}>
                {/* <a href="#javascript" onClick={showRightSidebar}>
                  <MessageCircle />
                  <span className="dot"></span>
                </a> */}
                <a onClick={goFull} className="text-dark" href="#!">
                  <Maximize />
                </a>
              </li>
              <UserMenu />
            </ul>
            <div
              className="d-lg-none mobile-toggle pull-right"
              onClick={() => setHeaderbar(!headerbar)}
            >
              <MoreHorizontal />
            </div>
          </div>
          <script id="result-template" type="text/x-handlebars-template">
            <div className="ProfileCard u-cf">
              <div className="ProfileCard-avatar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-airplay m-0"
                >
                  <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                  <polygon points="12 15 17 21 7 21 12 15"></polygon>
                </svg>
              </div>
              <div className="ProfileCard-details">
                <div className="ProfileCard-realName"></div>
              </div>
            </div>
          </script>
          <script id="empty-template" type="text/x-handlebars-template">
            <div className="EmptyMessage">
              Your search turned up 0 results. This most likely means the
              backend is down, yikes!
            </div>
          </script>
        </div>
      </div>
    </Fragment>
  );
};
export default Header;
